import { MatTableDataSource } from '@angular/material/table';
import { Component, DestroyRef, ViewChild, inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { ServicesService } from 'src/services/services.service';
import { MatSort } from '@angular/material/sort';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { finalize } from 'rxjs/operators';


export interface EventElement {
  event_id: string;
  event_name: string;
  event_type: string;
  description: string;
  address: string;
  from_date: string;
  to_date: string;
  event_logo: string;
  event_image: string;
  from_time: string;
  to_time: string;
  created_by: string;
  created_date: string;
  is_active: string;
  action: any;
}

@Component({
  selector: 'app-listing',
  templateUrl: './listing.component.html',
  styleUrls: ['./listing.component.scss'],
  standalone: false
})

export class ListingComponent {
  displayedColumns: string[] = [
    'event_id',
    'event_logo',
    'event_image',
    'event_name',
    'created_by',
    'created_date',
    'event_type',
    'address',
    'from_date',
    'to_date',
    'from_time',
    'to_time',
    'is_active',
    'description',
    'action',
  ];

  ELEMENT_DATA: EventElement[] = [];
  event_result: any;
  user_id: any;

  private destoryRef = inject(DestroyRef);

  dataSource = new MatTableDataSource<EventElement>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  constructor(private service: ServicesService,
    private router: Router,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) { }

  ngAfterViewInit() {
    const user_id = sessionStorage.getItem('User_ID');
    this.Get_Event(user_id);
    this.dataSource.paginator = this.paginator;
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  Get_Event(user_id: any) {
    this.ELEMENT_DATA = [];
    this.spinner.show();
    this.service.get_event_by_user(user_id).pipe(takeUntilDestroyed(this.destoryRef), finalize(() => this.spinner.hide())).subscribe(
      (data: any) => {
        this.event_result = data.data
        for (const item of this.event_result) {
          this.ELEMENT_DATA.push({
            event_id: item.event_id,
            event_name: item.event_name,
            created_by: item.created_by,
            created_date: item.created_date,
            event_type: item.event_type,
            description: item.description,
            address: item.address,
            from_date: item.from_date,
            to_date: item.to_date,
            event_logo: `https://aieventzo.com/upload/event_logo/` + item.event_logo,
            event_image: `https://aieventzo.com/upload/event_image/` + item.event_image,
            from_time: item.from_time,
            to_time: item.to_time,
            is_active: item.is_active == 1 ? "Active" : "Inactive",
            action: item.event_id
          });
          this.spinner.hide();
        }
        this.dataSource = new MatTableDataSource<EventElement>(this.ELEMENT_DATA);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );
  }

  Add_Event() {
    this.router.navigate(['/admin/Listings/AddListings']);
  }

  Edit_Event(event_id: any) {
    this.router.navigate(['/admin/Listings/EditListings', { 'event_id': event_id }]);
  }

  DeleteEvent(event_id: any) {
    const buttonClicked = window.confirm('Are You Sure To Delete This Event?');
    if (buttonClicked === true) {
      this.service.delete_event(event_id).pipe(takeUntilDestroyed(this.destoryRef)).subscribe(
        data => {
          this.ELEMENT_DATA = this.ELEMENT_DATA.filter(item => item.event_id !== event_id);
          this.dataSource.data = this.ELEMENT_DATA;
          this.toastr.success("Event Deleted Succesfully");
        });
    }
  }

  onCheckboxChange(user_id: any, element: any) {
    const isVerifiedValue = element.is_verified ? 1 : 0;
  }
}
